<template>
    <div class="main-nav--items">
        <div class="main-nav--row grid--row">
            <cmp-main-nav-item class="main-nav--col grid--col"
                    v-for="(child, idx) in root.children" :key="idx"
                    :facet="facet"
                    :child="child"
                    :is-fixed="isFixed"
                    :idx="idx"
                    :level="0">
                <span slot="link" class="main-nav--text" v-html="child.label"></span>
            </cmp-main-nav-item>
            <cmp-main-nav-item
                    class="main-nav--col grid--col"
                    :facet="facet"
                    :child="root"
                    :is-fixed="isFixed"
                    :show-sub-nav="false"
                    :level="0">
                <img slot="link" :src="logoUrl" :alt="root.label" class="u-reset main-nav--logo">
            </cmp-main-nav-item>
        </div>
    </div>
</template>


<script>
    import bemMixin from 'vue/mixins/bem';
    import navItemMixin from 'vue/mixins/nav-item';
    import viewportBoundariesMixin from 'vue/mixins/viewport-boundaries';


    export default {
        mixins: [
            bemMixin('main-nav'),
            navItemMixin,
            viewportBoundariesMixin,
        ],
        props: {
            structure: Array,
            logoUrl: String,
            isFixed: Boolean,
        },
        computed: {
            root() {
                return this.structure[0];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?53a51817